import React from 'react';

export default function Hint({ hint }) {
    if (!hint) {
        return null;
    }

    return <div className="mt-1 ml-0.5 text-xs text-grey-500">
        { hint }
    </div>
}
